module.exports = __webpack_public_path__ + "static/media/basketball.aec9da0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/basketball.svg
// module id = 361
// module chunks = 7